import { render, staticRenderFns } from "./PublicPopUps.vue?vue&type=template&id=f74ffada&scoped=true&"
import script from "./PublicPopUps.vue?vue&type=script&lang=ts&"
export * from "./PublicPopUps.vue?vue&type=script&lang=ts&"
import style0 from "./PublicPopUps.vue?vue&type=style&index=0&id=f74ffada&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74ffada",
  null
  
)

export default component.exports